import qs from 'querystring';
import isModal from './isModal';
import isPostMessageSupported from './isPostMessageSupported';
import noop from 'lodash/utility/noop';

// comunica con il container quando l'applicazione è ospitata in una modale
// e se il container supporta l'api postMessage()
export default function buildHeightNotifier(app) {

  const do_post = isPostMessageSupported() && isModal();

  if (!do_post) {
    return noop;
  }

  let height;

  return function () {

    // controllo se c'è una modale aperta
    const modalContainer = document.getElementById('modal-container');

    let do_scroll = document.getElementById('modal-container') && modalContainer.getAttribute("scroll") !== "sent";

    if (document.getElementById('modal-container')) {
      modalContainer.setAttribute("scroll", "sent");
    }

    const new_height = document.body.clientHeight;
    if (new_height !== height) {
      const message = qs.stringify({
        current_module: app.route.name,
        height: new_height,
        do_scroll: do_scroll
      });
      window.top.postMessage(message, '*');
      height = new_height;
    }
  };

}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/buildHeightNotifier.js
 **/